module.exports = __webpack_public_path__ + "static/media/021ty@4x.ef3aa144.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/021ty@4x.png
// module id = 423
// module chunks = 0 1